import { render, staticRenderFns } from "./UserAccessLogDetail.vue?vue&type=template&id=6cbb8d93&scoped=true&lang=pug"
import script from "./UserAccessLogDetail.vue?vue&type=script&lang=js"
export * from "./UserAccessLogDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbb8d93",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cbb8d93')) {
      api.createRecord('6cbb8d93', component.options)
    } else {
      api.reload('6cbb8d93', component.options)
    }
    module.hot.accept("./UserAccessLogDetail.vue?vue&type=template&id=6cbb8d93&scoped=true&lang=pug", function () {
      api.rerender('6cbb8d93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/tableau/components/user-access/UserAccessLogDetail.vue"
export default component.exports